import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import closeModal from '../../../actions/Modals/closeModal'
import { IRoomLimitsExceededModalDispatch } from './RoomLimitsExceededModal'

const bindDispatchToProps = (
  dispatch: Dispatch,
  ownProps,
): IRoomLimitsExceededModalDispatch => ({
  close: () => dispatch(closeModal(ownProps.modalId)),
})

export default connect(null, bindDispatchToProps)
